import { useEffect } from "react";

// Lightweight client-side SEO: sets title + meta tags + canonical + OG/Twitter
// + optional JSON-LD. Suitable for an SPA marketing site.
export default function SEO({ title, description, keywords, canonical, jsonLd, noindex }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — Prime Deal Gateway` : "Prime Deal Gateway";
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      if (content == null) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description || "By invitation. For verified principals only.");
    setMeta("name", "keywords", keywords || "private capital, off-market deals, family office, private credit");
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description || "By invitation. For verified principals only.");
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Prime Deal Gateway");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description || "By invitation. For verified principals only.");

    const url = canonical || window.location.href;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
    setMeta("property", "og:url", url);

    let ld;
    if (jsonLd) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.setAttribute("data-seo-jsonld", "true");
      ld.text = JSON.stringify(jsonLd);
      document.head.appendChild(ld);
    }
    return () => {
      if (ld && ld.parentNode) ld.parentNode.removeChild(ld);
    };
  }, [title, description, keywords, canonical, jsonLd, noindex]);

  return null;
}
